<script>

import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {

    PageHeader,
  },
  data() {
    return {
      HrComplains: [],
      HrComplainTypes: [],
      HrEmployees: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrComplains: null,
      HrComplainsSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addHrComplains() {
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "hr_employee_id",
            type: "select",
            options: (() => {
              return this.HrEmployees.map((data) => {
                return { value: data.id, label: data.name };
              });
            })(),
            label: "Employee",
          },
          {
            model: "hr_complain_type_id",
            type: "select",
            options: (() => {
              return this.HrComplainTypes.map((data) => {
                return { value: data.id, label: data.name };
              });
            })(),
            label: "Complain Type",
          },
          { model: "descr", type: "text", label: "Description" },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("hr-complains", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrComplains(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "hr_employee_id",
            type: "text",
            label: "Employee",
            value: app.hr_employee_id,
          },
          {
            model: "hr_complain_type_id",
            type: "text",
            label: "Complain Type",
            value: app.hr_complain_type_id,
          },
          {
            model: "descr",
            type: "text",
            label: "Description",
            value: app.descr,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("hr-complains", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.HrComplainsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-complains/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.HrComplains = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrComplainsSearchMode = false;
      this.get(this.page);
    },

    getHrComplains() {
      this.http.get("hr-complains").then((res) => {
        this.HrComplains = res.data;
      });
    },
    getHrComplainTypes() {
      this.http.get("hr-complain-types").then((res) => {
        this.HrComplainTypes = res.data;
      });
    },
    getHrEmployees() {
      this.http.get("hr-employees").then((res) => {
        this.HrEmployees = res.data;
      });
    },
    deleteHrComplains(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("hr-complains", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("hr-complains/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrComplains = res.data;
        });
    },
  },
  created() {
    this.get(1);
    this.getHrComplainTypes();
    this.getHrEmployees();
  },
};
</script>

<template>

    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.hr.subItems.complains')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="HrComplainsSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addHrComplains()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("hr_complains.id") }}</th>
          <th scope="col">{{ $t("hr_complains.hr_employee_id") }}</th>
          <th scope="col">{{ $t("hr_complains.hr_complain_type_id") }}</th>
          <th scope="col">{{ $t("hr_complains.descr") }}</th>
          <th scope="col">{{ $t("hr_complains.created") }}</th>
          <th scope="col">{{ $t("hr_complains.updated") }}</th>
          <th scope="col">{{ $t("hr_complains.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="app in HrComplains" :key="app" class="text-center">
          <td>{{ app?.id }}</td>
          <td>{{ app?.hr_employees?.name }}</td>
          <td>{{ app?.hr_complain_type?.name }}</td>
          <td>{{ app?.descr }}</td>
          <td>{{ app.created.split("T")[0] }}</td>
          <td>{{ app.updated.split("T")[0] }}</td>

          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editHrComplains(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteHrComplains(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  Pagination     -->
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->

</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
